//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
  IconColors,
} from '@hub/design-system-base'
import { default as ChevronDownSmallSVG } from './assets/small/chevron-down.inline.svg'

interface ChevronDownSmallIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
  color?: IconColors
}

export const ChevronDownSmallIcon: React.FC<
  React.PropsWithChildren<ChevronDownSmallIconProps>
> = forwardRef<ChevronDownSmallIconProps, typeof ChakraIcon>(
  ({ boxSize = 'size-icon-sm', sx, ariaLabel, color }, ref) => (
    <ChakraIcon
      ref={ref}
      boxSize={boxSize}
      aria-label={ariaLabel}
      as={ChevronDownSmallSVG}
      sx={sx}
      color={color}
    />
  )
)
